/**
 *
 */
import {Viewer} from 'photo-sphere-viewer';


/**
 * add virtual tour interface functionality
 *
 * @see https://photo-sphere-viewer.js.org/guide/
 * @see https://photo-sphere-viewer.js.org/guide/config.html
 */
const setupVirtualTourViewer = () =>
{
	const viewerElem = document.querySelector( '#virtual-tour-viewer' );

	if (viewerElem instanceof HTMLElement) {

		new Viewer( {
			container:      viewerElem,
			panorama:       viewerElem.dataset.panorama,
			defaultZoomLvl: 25,
		} );
	}
};


/**
 *
 */
export default setupVirtualTourViewer;